// extracted by mini-css-extract-plugin
export default {"container":"filesUpload_container__VHBDr"};